import { render, staticRenderFns } from "./InterestSetup.vue?vue&type=template&id=49688033&"
import script from "./InterestSetup.vue?vue&type=script&lang=js&"
export * from "./InterestSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports